import '@babel/polyfill';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { DndProvider } from 'react-dnd';
import MultiBackend, { TouchTransition, MouseTransition } from 'react-dnd-multi-backend';
import TouchBackend from 'react-dnd-touch-backend';
import HTML5Backend from 'react-dnd-html5-backend';
import { LocaleProvider, ConfigProvider } from 'antd';
import enUS from 'antd/es/locale-provider/en_US';
import 'moment/locale/hr';

import './styles';
import config from 'appConfig';
import hrHR from './locale/hr_HR';
import store from './store';
import history from './history';
import App from './containers/App/index';
import { getDropTargetElementsByPlatform, localStorage } from './services';
import { LocaleCode, LocalStorageKey } from './models';
import { setAgeVerified } from './routes/Ad/ad.ducks';


// TODO: Davor > remove from production
const googletag = window.googletag || {};
googletag.cmd = googletag.cmd || [];
googletag.cmd.push(function () {
  googletag.pubads().setTargeting('projekt', 'oglasi');
  googletag.pubads().addEventListener('slotRenderEnded', function (event) {
    if (event.isEmpty) {
      var id = event.slot.getSlotElementId();
      console.log('Google ad slot ' + id + ' is empty.');
    }
  });
});

const HTML5toTouch = {
  backends: [
    {
      backend: HTML5Backend,
      transition: MouseTransition,
    },
    {
      backend: TouchBackend,
      options: {
        enableMouseEvents: true,
        ignoreContextMenu: true,
        delayTouchStart: 200,
        getDropTargetElementsAtPoint: getDropTargetElementsByPlatform(),
      },
      preview: true,
      transition: TouchTransition,
    },
  ],
};

// Initialize age verification from localStorage
const isAgeVerified = localStorage.getItem(LocalStorageKey.isAgeVerified);
if (isAgeVerified !== null) {
  store.dispatch(setAgeVerified(isAgeVerified));
}

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <DndProvider
        backend={MultiBackend}
        options={HTML5toTouch}
      >
        <ConfigProvider locale={config.localeCode === LocaleCode.hr ? hrHR : enUS}>
            <App />
        </ConfigProvider>
      </DndProvider>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);

// Remove ServiceWorker because it make the app can't redirect to MVC action
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx